import { motion } from "framer-motion";
import { useState } from 'react';
import { HiMenuAlt4, HiX } from "react-icons/hi";
import { images } from '../../constants';
import './Navbar.scss';
const Navbar = () => {
  const [toggle, setToggle] = useState(false);

  return (
    <nav className="app__navbar">
      <div className="app__navbar-logo">
        <img
          src={images.logo}
          alt="Khaled Agha Logo"
          width={113}
          height={90}
        />
      </div>
      <ul className="app__navbar-links">
        {['home', 'about', 'work', 'skills', 'numbers', 'aitools', 'contact'].map((item) => (
          <li className="app__flex p-text" key={`link-${item}`}>
            <div />
            <a href={`#${item}`} aria-label={`Go to ${item} section`}>{item}</a>
          </li>
        ))}
      </ul>

      <div className="app__navbar-menu">
        <HiMenuAlt4 onClick={() => setToggle(true)} aria-label="Open Menu" />

        {toggle && (
          <motion.div
            whileInView={{ x: [300, 0] }}
            transition={{ duration: 0.85, ease: 'easeOut' }}
          >
            <HiX onClick={() => setToggle(false)} aria-label="Close Menu" />
            <ul>
              {['home', 'about', 'work', 'skills', 'numbers', 'aitools', 'contact'].map((item) => (
                <li key={item}>
                  <a href={`#${item}`} onClick={() => setToggle(false)} aria-label={`Go to ${item} section`}>
                    {item}
                  </a>
                </li>
              ))}
            </ul>
          </motion.div>
        )}
      </div>
    </nav>
  );
}

export default Navbar